import React from "react";
import Preloader from "./Preloader";
import Navbar from "./Navbar";
import Hero from "./Hero";
import Features from "./Features";
import About from "./About";
import Overview from "./Overview";
import Team from "./Team";
import Blog from "./Blog";
import Testimonials from "./Testimonials";
import Subscribe from "./Subscribe";
import Contact from "./Contact";
import Faq from "./Faq";
import Footer from "./Footer";
import { Toaster } from "./ui/toaster";

export default function HomePage() {
  return (
    <>
      <Preloader />
      <Navbar />
      <main>
        <Hero />
        <Features />
        <About />
        <Overview />
        <Team />
        <Blog />
        <Testimonials />
        <Subscribe />
        <Contact />
        <Faq />
      </main>
      <Footer />
      <Toaster />
    </>
  );
}
